import { darken, lighten } from "polished";
import theme from "styled-theming";

export const tableTextColor = theme("mode", {
  light: "#646777",
  dark: "red",
});

export const colorBackground = theme("mode", {
  light: "white",
  dark: "#232329",
});
export const scrollBarColor = theme("mode", {
  light: "#f1f1f1",
  dark: "#777",
});
export const colorBackgroundDropdown = theme("mode", {
  light: "#232329",
  dark: "white",
});
export const borderNewtab = theme("mode", {
  light: "#232329",
  dark: "white",
});
export const borderColor = theme("mode", {
  light: "#232329",
  dark: "#dddddd",
});
export const borderColorvm = theme("mode", {
  light: "#999",
  dark: "#aaa",
});
export const textcolorNotificationBackgroundhover = theme("mode", {
  light: "#000",
  dark: "white",
});
export const colorNotificationBackgroundhover = theme("mode", {
  light: "#eee",
  dark: "#242526",
});

export const colorBackgroundBody = theme("mode", {
  light: "#f2f4f7",
  dark: "#2a2a31",
});

export const inboxButtonBackground = theme("mode", {
  light: "#f2f4f7",
  dark: "#2a2a31",
});

export const inboxButtonBackgroundHover = theme("mode", {
  light: darken(0.05, "#f2f4f7"),
  dark: lighten(0.05, "#2a2a31"),
});

export const colorHeaderDataPicker = theme("mode", {
  light: "#6db0ff",
  dark: "#063263",
});

export const muiTreeColor = theme("mode", {
  light: "#3b5aa9",
  dark: "#dddddd",
});

export const colorText = theme("mode", {
  light: "#646777",
  dark: "#dddddd",
});

export const colorDarkText = theme("mode", {
  light: "#555555",
  dark: "#dddddd",
});

export const colorTextAdditional = theme("mode", {
  light: "#646777",
  dark: "#999999",
});

export const logoImg = theme("mode", {
  light: `url(/logo.webp)`,
  dark: `url(/logo.webp)`,
});

export const colorHover = theme("mode", {
  light: "#fafbfe",
  dark: "#38373f",
});

export const selectColorHover = theme("mode", {
  light: "#e9ebf2",
  dark: "#38373f",
});
export const vulnerabilityPanelLabel = theme("mode", {
  light: "#fafbfe",
  dark: "#38373f",
});

export const colorFolderHover = theme("mode", {
  light: "#f0eeee",
  dark: "#ffffff1A",
});

export const colorBorder = theme("mode", {
  light: "#eff1f5",
  dark: "#333246",
});

export const colorIcon = theme("mode", {
  light: "#dddddd",
  dark: "#605f7b",
});

export const imgInvert = theme("mode", {
  light: "invert(0%)",
  dark: "invert(100%)",
});

export const colorFieldsBorder = theme("mode", {
  light: "#f2f4f7",
  dark: "#33333a",
});

export const colorBubble = theme("mode", {
  light: "rgba(242, 244, 247, 0.65)",
  dark: "rgba(68, 79, 97, 0.65)",
});

export const colorBubbleActive = theme("mode", {
  light: "rgba(234, 238, 255, 0.6)",
  dark: "rgba(92, 104, 156, 0.6)",
});

export const colorScrollbar = theme("mode", {
  light: "#B4BFD0",
  dark: "#606071",
});

export const colorFitness = theme("mode", {
  light: "#646777",
  dark: "#ffffff",
});

export const colorEmoji = theme("mode", {
  light: "#232329",
  dark: "#ffffff",
});

export const sidebarColor = theme("mode", {
  light: "aliceblue",
  dark: "#232329",
});

export const colorBackgroundDark = theme("mode", {
  light: "#222",
  dark: "#555",
});

export const colorTextDark = theme("mode", {
  light: "#646777",
  dark: "#dddddd",
});
export const richTextIcons = theme("mode", {
  light: "#646777",
  dark: "#3258B7",
});

export const alertTableColor = theme("mode", {
  light: "#ffcdd2",
  dark: "#ffebee",
});

export const colorAccent = "#3258B7"; // Low
export const colorLightAccent = "#55e5bb";
export const colorAccentHover = darken(0.1, colorAccent);
export const colorAdditional = "#999999";
export const colorAdditionalHover = darken(0.1, colorAdditional);

export const colorYellow = "#e0aa2d";
export const colorLightYellow = "#f4dd87"; // Medium
export const colorYellowHover = darken(0.1, colorYellow);

export const colorViolet = "#c88ffa";

export const colorRed = "#de0a26"; // High
export const colorDarkRed = "#721c24"; // Critical
export const colorLightRed = "#f88e7d"; // Medium risk
export const colorVeryLightRed = "#f8d7da";
export const colorRedHover = darken(0.1, colorRed);

export const colorBlue = "#3258B7";
export const colorLightBlue = "#87c3f7";
export const colorBlueHover = darken(0.1, colorBlue);
// export const colorBlueHover = darken(0.1, colorRed)

export const colorBlack = "#000000";
export const colorGray = "#787985";
export const colorLightGray = "#d8dfe9";
export const colorDustyWhite = "#dddddd";
export const colorDustyWhite2 = "#aaaaaa";
export const colorWhite = "#ffffff";

export const colorGreen = "#36b37e"; // None
export const colorGreenHover = darken(0.1, colorGreen);

export const colorDarkFieldsBorder = "#33333a";
export const colorBlackBackground = "#232329";
// export const colorBackgroundBody= '#f2f4f7';
export const colorLightText = "#646777";
// export const colorHover = '#fafbfe';

// Color Palette
export const paletteBlueDarkest = "#070D1c";
export const paletteBlue2 = "#202D4D";
export const paletteCompanyColor = "#3258B7";
export const paletteBlueLight = "#7186B3";

export const landingAccentColor = "#244153";
export const landingButtonColor = "#2C86A2";
export const landingSaffronColor = "#ffde2c";
export const landingGradient =
  "linear-gradient(228deg, rgba(127, 244, 222, 0.95), rgba(56, 199, 225, 1))";
// eslint-disable-next-line max-len
export const landingGradientColor =
  "linear-gradient(228deg, darken(rgba(127, 244, 222, 0.95), 5%), darken(rgba(56, 199, 225, 1), 5%))";
export const landingGradientBtn =
  "linear-gradient(228deg, rgb(127, 244, 222), rgb(62, 59, 224))";
// eslint-disable-next-line max-len
export const landingGradientBtnHover =
  "linear-gradient(228deg, darken(rgb(127, 244, 222), 5%), darken(rgb(62, 59, 224), 5%))";

export const scrollbarStyles = props => `
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    opacity: 0.3;
  }
  
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    border: 1px solid transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: ${colorScrollbar(props)};
  }   
`;

export const statusColor = status => {
  switch (status) {
    // case 'Closed':
    //   return 'black'
    case "Escalated":
    case "delete":
    case "OFFLINE":
    case "Error":
      return "red";
    case "Pending":
    case "PENDING":
    case "NEEDS REVIEW":
    case "shutdown":
      return "yellow";
    case "Not In Service":
    case "To Do":
    case "SELECTED FOR DEVLOPMENT":
      return "gray";
    case "Cancelled":
    case "Resolved":
    case "Declined":
    case "Denied":
    case "Failed":
    case "Done":
    case "DONE":
    case "Completed":
    case "poweron":
    case "online":
    case "RUNNING":
    case "Closed":
      return "green";
    case "In Progress":
    case "In progress":
    case "Awaiting Implementation":
    case "awaiting implementation":
    case "In Service":
      return `blue`;
    default:
      return "blue";
  }
};
export const colorPalette = [
  "#F6DDCC",
  "#00CED1",
  "#BDC3C7",
  "#EE82EE",
  "#F0E68C",
  "#7FB3D5",
  "#F5CBA7",
  "#7D9EC0",
  "#85929E",
  "#F4A300",
  "#FF9F00",
  "#FF7100",
  "#FF1493",
  "#FF8C00",
  "#FF7F50",
  "#FF0000",
  "#DC143C",
  "#FF6B6B",
  "#FF7F50",
  "#FF4500",
  "#9ACD32",
  "#32CD32",
  "#228B22",
  "#008000",
  "#00FA9A",
  "#00FF00",
  "#20B2AA",
  "#4682B4",
  "#0000FF",
  "#1E90FF",
  "#87CEFA",
  "#ADD8E6",
  "#4169E1",
  "#8A2BE2",
  "#9400D3",
  "#9932CC",
  "#8B008B",
  "#800080",
  "#BA55D3",
  "#DDA0DD",
  "#F5DEB3",
  "#D4E157",
  "#8B0000",
  "#B22222",
  "#C71585",
  "#FF00FF",
  "#D2691E",
  "#FFDAB9",
  "#F4A300",
  "#FA8072",
  "#F5B7B1",
  "#F0B27A",
  "#F9E79F",
  "#A3E4D7",
  "#A2D9CE",
  "#A9DFBF",
  "#ABEBC6",
  "#D0ECE7",
  "#E8DAEF",

  "#F7DC6F",
  "#F39C12",
  "#F4D03F",
  "#E67E22",
  "#D35400",
  "#D45B3A",
  "#D44F00",
  "#AF7AC5",
  "#D7DBD9",
  "#9B59B6",
  "#8E44AD",
  "#2C3E50",
  "#34495E",
  "#A9DFBF",
  "#A3E4D7",
  "#7FB3D5",
  "#A2D9CE",
  "#4A235A",
  "#512E5F",
  "#7D3C98",
  "#641E16",
  "#1F618D",
  "#21618C",
  "#117A65",
  "#1D8348",
  "#45B39D",
  "#2980B9",
  "#2874A6",
  "#5499C7",
];
